import {radialProgressiveBlur} from '@remotion/effects/radial-progressive-blur';
import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {
	AbsoluteFill,
	Composition,
	Easing,
	HtmlInCanvas,
	interpolate,
	useCurrentFrame,
} from 'remotion';

export const CloseUp5Preview = () => {
	const frame = useCurrentFrame();
	const captureFrame = frame + 164;

	return (
		<HtmlInCanvas
			style={{width: 3216, height: 2610}}
			width={3216}
			height={2610}
			effects={[
				radialProgressiveBlur({
					center: [0.3, 0.207],
					height: 0.739,
					width: 0.793,
					endBlur: 32,
				}),
			]}
		>
			<AbsoluteFill
				name="Canvas Capture"
				style={{
					width: 3216,
					height: 2610,
					translate: interpolate(
						captureFrame - 164,
						[34, 79],
						['-123.2px -277.3px', '-168.2px -1032.6px'],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
							easing: [
								Easing.spring({
									damping: 200,
									mass: 1,
									stiffness: 100,
									allowTail: true,
									durationRestThreshold: 0.02,
									overshootClamping: false,
								}),
							],
						},
					),
					rotate: '0.623179 0.78185 0.018931 23.289507deg',
				}}
				from={-164}
			>
				<Video
					src="https://remotion.media/studio-close-ups/studio-effects-editing.mp4"
					style={{
						position: 'absolute',
					}}
				/>
				<MacOSCursor
					cursor={interpolate(
						frame,
						[15, 130, 274, 275, 315, 316, 340, 344, 517, 518, 525, 633, 656],
						[
							'auto',
							'default',
							'auto',
							'pointer',
							'default',
							'auto',
							'default',
							'ew-resize',
							'auto',
							'default',
							'auto',
							'pointer',
							'auto',
						],
						{
							easing: Easing.step1,
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					)}
					style={{
						position: 'absolute',
						left: 0,
						top: 0,
						scale: interpolate(
							captureFrame,
							[0, 181, 251, 300, 305, 359, 438],
							[7, 6.3, 7, 6.3, 7, 6.3, 7],
							{
								easing: [
									Easing.step1,
									Easing.step1,
									Easing.step1,
									Easing.step1,
									Easing.step1,
									Easing.step1,
								],
								extrapolateLeft: 'clamp',
								extrapolateRight: 'clamp',
							},
						),
						translate: interpolate(
							captureFrame,
							[
								15, 123, 124, 125, 126, 127, 128, 129, 130, 131, 132, 133, 134,
								135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147,
								148, 149, 150, 151, 154, 155, 156, 157, 158, 159, 160, 161, 162,
								163, 164, 165, 166, 167, 168, 169, 170, 172, 173, 180, 181, 196,
								197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209,
								210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222,
								223, 224, 225, 226, 227, 228, 229, 231, 232, 233, 234, 235, 236,
								237, 238, 239, 240, 241, 242, 243, 244, 245, 249, 250, 269, 270,
								271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283,
								284, 285, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323,
								324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336,
								337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349,
								350, 351, 352, 353, 376, 377, 378, 379, 380, 381, 382, 383, 384,
								385, 386, 387, 388, 389, 390, 391, 392, 393, 394, 395, 396, 397,
								398, 399, 400, 401, 402, 403, 404, 405, 406, 407, 408, 409, 410,
								411, 412, 413, 414, 415, 416, 417, 418, 419, 516, 517, 518, 519,
								520, 521, 522, 523, 524, 525, 526, 632, 633, 655, 656,
							],
							[
								'-3819.921875px 521.6640625px',
								'-3819.921875px 521.6640625px',
								'2652.5078125px 672.08203125px',
								'2592.078125px 672.08203125px',
								'2535.75px 672.08203125px',
								'2479.421875px 677.76953125px',
								'2303.90234375px 709.1328125px',
								'2088.1328125px 754.4140625px',
								'1891.421875px 787.85546875px',
								'1766.81640625px 805.328125px',
								'1644.31640625px 831.5234375px',
								'1521.81640625px 866.46875px',
								'1441.890625px 895.31640625px',
								'1396.3359375px 906.69140625px',
								'1359.50390625px 917.0546875px',
								'1342.76953125px 924.3828125px',
								'1332.70703125px 924.3828125px',
								'1330.02734375px 927.03515625px',
								'1327.8125px 927.03515625px',
								'1327.8125px 927.03515625px',
								'1325.92578125px 927.03515625px',
								'1289.09375px 927.03515625px',
								'1252.26171875px 927.03515625px',
								'1206.70703125px 927.03515625px',
								'1169.875px 927.03515625px',
								'1141.765625px 927.03515625px',
								'1127px 927.03515625px',
								'1116.9375px 927.03515625px',
								'1114.2578125px 927.03515625px',
								'1112.04296875px 927.03515625px',
								'1112.04296875px 927.03515625px',
								'1112.04296875px 925.203125px',
								'1112.04296875px 925.203125px',
								'1110.1015625px 925.203125px',
								'1110.1015625px 920.7734375px',
								'1107.421875px 918.09375px',
								'1107.421875px 912.734375px',
								'1107.421875px 907.375px',
								'1107.421875px 907.375px',
								'1107.421875px 902.48046875px',
								'1107.421875px 897.12109375px',
								'1107.421875px 892.2265625px',
								'1107.421875px 889.546875px',
								'1107.421875px 887.33203125px',
								'1107.421875px 887.33203125px',
								'1107.421875px 885.30859375px',
								'1105.48046875px 885.30859375px',
								'1105.48046875px 885.30859375px',
								'1103.59375px 885.30859375px',
								'1103.59375px 885.30859375px',
								'1102.69140625px 885.30859375px',
								'1102.69140625px 885.30859375px',
								'1101.7890625px 891.21484375px',
								'1101.7890625px 906.6640625px',
								'1101.7890625px 933.40625px',
								'1099.79296875px 962.2265625px',
								'1099.79296875px 962.2265625px',
								'1090.4140625px 1020.11328125px',
								'1085.4921875px 1049.53515625px',
								'1080.59765625px 1072.0390625px',
								'1073.515625px 1100.23046875px',
								'1068.8125px 1132.66015625px',
								'1064.109375px 1162.13671875px',
								'1062.66015625px 1206.10546875px',
								'1058.83203125px 1232.02734375px',
								'1056.04296875px 1252.234375px',
								'1055.6875px 1268.06640625px',
								'1052.26953125px 1283.3515625px',
								'1052.05078125px 1291.0078125px',
								'1051.88671875px 1313.78515625px',
								'1048.16796875px 1328.76953125px',
								'1048.16796875px 1343.48046875px',
								'1048.16796875px 1356.60546875px',
								'1048.16796875px 1367.734375px',
								'1048.16796875px 1380.01171875px',
								'1048.16796875px 1394.8046875px',
								'1048.16796875px 1405.93359375px',
								'1048.16796875px 1416.40625px',
								'1048.16796875px 1426.76953125px',
								'1048.16796875px 1434.91796875px',
								'1048.16796875px 1440.49609375px',
								'1048.16796875px 1443.23046875px',
								'1048.16796875px 1445.6640625px',
								'1048.16796875px 1445.6640625px',
								'1048.16796875px 1447.6328125px',
								'1048.16796875px 1447.6328125px',
								'1048.16796875px 1449.4375px',
								'1048.16796875px 1449.4375px',
								'1048.16796875px 1451.3515625px',
								'1048.16796875px 1453.375px',
								'1048.16796875px 1455.453125px',
								'1049.48046875px 1456.46484375px',
								'1050.79296875px 1457.44921875px',
								'1051.55859375px 1458.43359375px',
								'1052.76171875px 1459.36328125px',
								'1054.23828125px 1461.33203125px',
								'1055.38671875px 1463.46484375px',
								'1057.6015625px 1466.0078125px',
								'1058.72265625px 1467.34765625px',
								'1059.84375px 1468.7421875px',
								'1059.84375px 1468.7421875px',
								'1060.74609375px 1470.08203125px',
								'1060.74609375px 1470.08203125px',
								'1060.74609375px 1480.8828125px',
								'1070.09765625px 1508.9375px',
								'1082.12890625px 1530.3203125px',
								'1094.16015625px 1551.703125px',
								'1101.48828125px 1566.4140625px',
								'1108.81640625px 1581.125px',
								'1113.4921875px 1595.15234375px',
								'1119.80859375px 1605.16015625px',
								'1125.11328125px 1610.46484375px',
								'1127.765625px 1620.47265625px',
								'1130.41796875px 1628.4296875px',
								'1132.60546875px 1630.6171875px',
								'1132.60546875px 1633.26953125px',
								'1132.60546875px 1635.45703125px',
								'1134.79296875px 1635.45703125px',
								'1134.79296875px 1637.64453125px',
								'1134.79296875px 1637.64453125px',
								'1147.37109375px 1637.64453125px',
								'1193.71875px 1637.64453125px',
								'1286.4140625px 1637.64453125px',
								'1342.6875px 1637.64453125px',
								'1390.23828125px 1637.64453125px',
								'1484.984375px 1637.64453125px',
								'1554.08203125px 1637.64453125px',
								'1623.1796875px 1637.64453125px',
								'1749.3984375px 1637.64453125px',
								'1805.671875px 1637.64453125px',
								'1853.22265625px 1637.64453125px',
								'1883.328125px 1637.64453125px',
								'1900.0078125px 1637.64453125px',
								'1910.015625px 1637.64453125px',
								'1920.0234375px 1637.64453125px',
								'1930.03125px 1637.64453125px',
								'1940.0390625px 1637.64453125px',
								'1954.75px 1637.64453125px',
								'1969.4609375px 1637.64453125px',
								'1990.84375px 1637.64453125px',
								'2012.2265625px 1637.64453125px',
								'2040.28125px 1637.64453125px',
								'2061.6640625px 1637.64453125px',
								'2098.44140625px 1637.64453125px',
								'2126.49609375px 1637.64453125px',
								'2154.55078125px 1637.64453125px',
								'2169.26171875px 1637.64453125px',
								'2183.97265625px 1637.64453125px',
								'2193.98046875px 1637.64453125px',
								'2206.640625px 1637.64453125px',
								'2216.6484375px 1637.64453125px',
								'2226.65625px 1637.64453125px',
								'2231.9609375px 1637.64453125px',
								'2234.61328125px 1637.64453125px',
								'2236.80078125px 1637.64453125px',
								'2238.796875px 1637.64453125px',
								'2241.44921875px 1637.64453125px',
								'2243.63671875px 1637.64453125px',
								'2245.82421875px 1637.64453125px',
								'2247.8203125px 1637.64453125px',
								'2247.8203125px 1637.64453125px',
								'2248.640625px 1637.64453125px',
								'2258.73046875px 1637.64453125px',
								'2276.09375px 1637.64453125px',
								'2286.8125px 1637.64453125px',
								'2319.953125px 1637.64453125px',
								'2348.609375px 1637.64453125px',
								'2370.703125px 1637.64453125px',
								'2388.77734375px 1637.64453125px',
								'2406.82421875px 1637.64453125px',
								'2415.95703125px 1637.64453125px',
								'2453.47265625px 1637.64453125px',
								'2490.16796875px 1637.64453125px',
								'2535.44921875px 1637.64453125px',
								'2570.96875px 1637.64453125px',
								'2585.98046875px 1637.64453125px',
								'2638.42578125px 1637.64453125px',
								'2661.12109375px 1637.64453125px',
								'2686.359375px 1637.64453125px',
								'2711.078125px 1637.64453125px',
								'2741.62109375px 1637.64453125px',
								'2759.94140625px 1637.64453125px',
								'2775.828125px 1637.64453125px',
								'2791.16796875px 1637.64453125px',
								'2802.37890625px 1637.64453125px',
								'2810.80078125px 1637.64453125px',
								'2818.703125px 1637.64453125px',
								'2823.734375px 1637.64453125px',
								'2836.9140625px 1636.3046875px',
								'2839.62109375px 1634.96484375px',
								'2852.28125px 1634.96484375px',
								'2855.7265625px 1634.96484375px',
								'2866.1171875px 1634.96484375px',
								'2871.8046875px 1634.96484375px',
								'2881.34765625px 1634.96484375px',
								'2884.4921875px 1634.96484375px',
								'2893.078125px 1634.96484375px',
								'2898.6015625px 1634.96484375px',
								'2904.125px 1634.96484375px',
								'2909.59375px 1634.96484375px',
								'2912.24609375px 1634.96484375px',
								'2914.65234375px 1634.96484375px',
								'2916.62109375px 1634.96484375px',
								'2917.46875px 1633.92578125px',
								'2917.46875px 1633.92578125px',
								'2909.73046875px 1584.16015625px',
								'2874.73046875px 1461.66015625px',
								'2816.05078125px 1305.19921875px',
								'2700.359375px 943.22265625px',
								'2556.01171875px 494.18359375px',
								'2463.64453125px 202.125px',
								'2358.75390625px -187.4140625px',
								'2264.3359375px -496.3984375px',
								'2221.05078125px -661.25390625px',
								'2191.68359375px -817.71484375px',
								'2191.68359375px -817.71484375px',
								'799.0390625px -420.3828125px',
								'799.0390625px -420.3828125px',
								'-4064.2109375px 7.90234375px',
							],
							{
								extrapolateLeft: 'clamp',
								extrapolateRight: 'clamp',
							},
						),
					}}
				/>
			</AbsoluteFill>
		</HtmlInCanvas>
	);
};

export const CloseUp5 = () => {
	return (
		<Composition
			id="EditEffects"
			component={CloseUp5Preview}
			width={1920}
			height={1080}
			fps={60}
			durationInFrames={150}
		/>
	);
};
